import { IRaffleDefaultRewardDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { useEffect, useState } from "react";
import { RaffleDefaultNumberRewardInfo } from "./rewardInfo";

interface IProps {
  rewards: IRaffleDefaultRewardDTO[];
}

export function RaffleDefaultNumberRewards({ rewards }: IProps) {
  const [reward, setReward] = useState<IRaffleDefaultRewardDTO | undefined>(
    undefined
  );

  useEffect(() => {
    setReward(rewards[0]);
  }, [rewards]);

  return (
    <>
      {rewards.length > 0 ? (
        <>
          <nav className="visit-reward-tabs" aria-label="Selecionar prêmio">
                  {rewards.map((item, i) => (
                      <button
                        key={`${item?.order}-${item?.name}-${i}`}
                        type="button"
                        className={`visit-reward-tab ${reward === item ? "active" : ""}`}
                        onClick={() => setReward(item)}
                      >
                        {item.thumb && <img src={item.thumb} alt="" />}
                        <span>{item.name}</span>
                      </button>
                  ))}
          </nav>
          {reward ? (
            <RaffleDefaultNumberRewardInfo reward={reward} />
          ) : (
            <div className="text-center">
              <span>Selecione um prêmio.</span>
            </div>
          )}
        </>
      ) : (
        <span>Nenhum prêmio encontrado.</span>
      )}
    </>
  );
}
